module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 1 RED.790bf55.svg";